import { Field, FieldProps } from 'formik';
import { FC } from 'react';
import Error from '../error';
import { FormikInputType, STANDARD_INPUT_HEIGHT } from '../input';
import { Label } from '../label';
import React from 'react';

export type TextAreaProps = FormikInputType &
  React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> & {
    inputClassName?: string;
    containerClassName?: string;
    rows?: number;
  };

export const TextArea = React.memo((props: TextAreaProps) => {
  const CustomField: FC<FieldProps> = ({ ...formikFieldProps }) => {
    const error = formikFieldProps.form.errors[props.name];
    const touched = formikFieldProps.form.touched[props.name];
    const { inputClassName: _, ...rest } = props;
    return (
      <div className={`flex-1 ${props.containerClassName}`}>
        <Label name={props.name} label={props.label} info={props.info} />
        <div
          className={`border-1.5 rounded-small flex items-center gap-x-2 bg-white pl-3 pt-1 ${
            touched && error ? 'border-danger' : 'border-grey-300'
          } focus-within:border-primary`}
          style={{
            minHeight: STANDARD_INPUT_HEIGHT,
          }}
        >
          {props.prefix && <div className=" text-grey-600 rounded-l-small">{props.prefix}</div>}
          <textarea
            {...rest}
            readOnly={props.readOnly === true}
            placeholder={props.placeholder}
            rows={props.rows || 5}
            className={`placeholder:text-grey-600 rounded-small flex-1 text-black focus:outline-none ${props.inputClassName}`}
            {...formikFieldProps.field}
            {...formikFieldProps.meta}
            
          />
        </div>
        <Error name={props.name} />
      </div>
    );
  };

  return <Field name={props.name} component={CustomField} />;
});
